module.exports = {"330424001":"武原街道","330424002":"西塘桥街道","330424003":"元通街道","330424004":"秦山街道","330424101":"沈荡镇","330424102":"百步镇","330424103":"于城镇","330424105":"澉浦镇","330424106":"通元镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330424.json
// module id = 903
// module chunks = 0